import { isAxiosError } from 'axios';
import type { CancelAssurantServiceResponseDTO } from '~/dto/Assegurou/cancelAssurantService';
import apiAssegurou from '~/services/apiAssegurou';

export async function cancelAssurantServiceUseCase({
  certificateCode,
  cancelReasonCode,
}: {
  certificateCode: string;
  cancelReasonCode: string;
}): Promise<boolean> {
  try {
    const response = await apiAssegurou.post<CancelAssurantServiceResponseDTO>(
      'v1/Protecao/CancelarSeguroAssurant',
      {
        codigoCertificado: certificateCode,
        codMotivo: cancelReasonCode,
        dataCancelamento: new Date().toISOString(),
      }
    );

    return response.data.success;
  } catch (err) {
    if (isAxiosError(err) && err.response?.data?.message) {
      throw {
        message: err.response?.data?.message,
      };
    }
    throw {
      message: null,
    };
  }
}
